export default "__VITE_ASSET__CbPVFYG0__"